import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {UtilsService} from "./utils.service";

@Injectable({
  providedIn: 'root'
})
export class GeocodingService {

  endpoint = environment.GEOCODING_SERVER_URL;

  constructor(
    private http: HttpClient,
    private utilsService: UtilsService) {
  }

  fetchGeocodingData(locationDetailsMap) {
    let params = new HttpParams();
    if (!this.utilsService.isNullOrEmpty(locationDetailsMap["city"])) {
      params =  params.set("city", locationDetailsMap["city"])
    }
    if (!this.utilsService.isNullOrEmpty(locationDetailsMap["street"])) {
      params =  params.set("street", locationDetailsMap["street"])
    }
    if(!this.utilsService.isNullOrEmpty(locationDetailsMap["streetNumber"])) {
      params = params.set("housenumber", locationDetailsMap["streetNumber"])
    }
    if (!this.utilsService.isNullOrEmpty(locationDetailsMap["countryName"])) {
      params =  params.set("country", locationDetailsMap["countryName"])
    }
    if (!this.utilsService.isNullOrEmpty(locationDetailsMap["district"])) {
      params = params.set("state", locationDetailsMap["district"])
    }
    params = params.set("format", "json")
    params = params.set("apiKey", environment.GEOAPIFY_API_KEY)

    return this.http
      .get<any>(
        this.endpoint , {params: params})
      .pipe(
        map(responseData => {
          return responseData?.results;
        })
      )
  }
}
